import { render, staticRenderFns } from "./Input2FormItem.vue?vue&type=template&id=7f686b55&scoped=true&"
import script from "./Input2FormItem.vue?vue&type=script&lang=js&"
export * from "./Input2FormItem.vue?vue&type=script&lang=js&"
import style0 from "./Input2FormItem.vue?vue&type=style&index=0&id=7f686b55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f686b55",
  null
  
)

export default component.exports